import { connectStateResults } from 'react-instantsearch-dom';

/**
 * Search results wrapper that only renders when there's a search query
 */
const SearchResultsWrapper = connectStateResults(
  ({ searchState, children }) => {
    if (!searchState.query) {
      return null;
    }
    return children;
  }
);

export default SearchResultsWrapper;
